export default {
  // 'homeManage.infoPlatform': '信息平台',
};
